var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notifications-active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11513",
    "data-name": "Path 11513",
    d: "M0,0H18V18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M13.175,11.846V8.385a4.22,4.22,0,0,0-3.132-4.375V3.538A1.046,1.046,0,0,0,8.992,2.5,1.034,1.034,0,0,0,7.955,3.538v.471A4.208,4.208,0,0,0,4.823,8.385v3.462l-.9.893a.692.692,0,0,0,.487,1.184h9.166a.694.694,0,0,0,.494-1.184ZM8.992,16a1.392,1.392,0,0,0,1.392-1.385H7.6A1.388,1.388,0,0,0,8.992,16ZM5.359,4.044a.68.68,0,0,0,.021-.99.7.7,0,0,0-.967-.014,7.206,7.206,0,0,0-2.276,4.2.7.7,0,0,0,.7.8.693.693,0,0,0,.682-.575A5.834,5.834,0,0,1,5.359,4.044Zm8.233-1a.707.707,0,0,0-.974.014.677.677,0,0,0,.021.983,5.872,5.872,0,0,1,1.844,3.42.682.682,0,0,0,.682.575.7.7,0,0,0,.689-.8A7.25,7.25,0,0,0,13.592,3.04Z",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsActive);
export default __webpack_public_path__ + "static/media/notifications-active.95530c4757006af3be339c2f316155f0.svg";
export { ForwardRef as ReactComponent };